import { render, staticRenderFns } from "./connected-answer.vue?vue&type=template&id=1239b6f4&scoped=true"
import script from "./connected-answer.vue?vue&type=script&lang=js"
export * from "./connected-answer.vue?vue&type=script&lang=js"
import style0 from "./connected-answer.vue?vue&type=style&index=0&id=1239b6f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1239b6f4",
  null
  
)

export default component.exports